type AddIconProps = {
  iconColor?: string;
};

export default function AddIcon({ iconColor = "currentColor" }: AddIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M0.8125 7H13.1875M7 0.8125V13.1875"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
